module.exports = __webpack_public_path__ + "static/media/empty-heart.fc6ad7eb.svg";